import { useQuery } from "@tanstack/react-query";
import type { ThemeWithVersions } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseThemeByIdQueryParams = {
  themeId: string;
};

export function useThemeByIdQuery({ themeId }: UseThemeByIdQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.admin.themeById(themeId),
    queryFn: () =>
      apiJsonClient<ThemeWithVersions>(endpoints.admin.themeById(themeId)),
    enabled: themeId.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
